import { Injectable } from "@angular/core";
import { AngularFireStorage } from "@angular/fire/compat/storage";
import { Store } from "@ngxs/store";
import { from, switchMap, catchError, map } from "rxjs";
import { environment } from "src/environments/environment";
import { UserState } from "../states/user.state";
import { ApiService } from "./api.service";
import { v1 as uuid } from "uuid";
import { UpdatePlaceLogo } from "../states/actions/user.actions";

@Injectable({
  providedIn: "root",
})
export class FilePlaceService {
  constructor(
    private store: Store,
    private storage: AngularFireStorage,
    private apiService: ApiService
  ) {}

  uploadAndUpdatePlacePicture(file: File) {
    const { selectedPlace } = this.store.selectSnapshot(UserState);
    const uuidImage = uuid();
    const FirebaseId = `place/logo-${uuidImage}.png`;
    const fileRef = this.storage.ref(FirebaseId);
    const task = this.storage.upload(FirebaseId, file);

    return from(task).pipe(
      switchMap(() => fileRef.getDownloadURL()),
      switchMap((downloadURL: string) => {
        return this.apiService
          .updatePlacePicture(selectedPlace.id, downloadURL, FirebaseId, 3)
          .pipe(map((res) => res.data.newFile));
      }),
      map((newFile) => {
        this.store.dispatch(new UpdatePlaceLogo(newFile));
        return newFile;
      }),
      catchError((error) => {
        console.error("Error actualizando foto:", error);
        throw error;
      })
    );
  }
}
